// Task form ↔ API payload (spec §10.2). Pure.

export const DRAFT_CLOSE_TEXT = 'Черновик задачи будет удалён. Закрыть окно?';
export const DRAFT_CLOSE_OK = 'Закрыть';
export const NO_WORKS_CONFIRM_TEXT = 'В этой задаче не выбрано ни одной работы. Вы уверены, что хотите сохранить задачу без выбранных работ?';
export const NO_WORKS_CONFIRM_OK = 'Сохранить';
export const CANCEL_TASK_OK = 'Отменить задачу';
export const cancelTaskText = (id, { onMap = true } = {}) =>
  `Отменить задачу T‑${id}? Задача перейдёт в статус «Отменена»${onMap ? ' и исчезнет с карты' : ''}.`;

const ACTIVE_CODES = ['assigned', 'in_progress'];
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

const present = (v) => v !== null && v !== undefined && String(v).trim() !== '';
const toNumber = (v) => Number(v);

export function isActiveTask(task) {
  return !!(task && task.status && ACTIVE_CODES.includes(task.status.code));
}

export function emptyTaskForm() {
  return { assignee_id: '', deadline_date: '', work_type_ids: [], description: '', expenses: '' };
}

export function formFromTask(task) {
  const t = task || {};
  return {
    assignee_id: present(t.assignee_id) ? t.assignee_id : '',
    deadline_date: present(t.deadline_date) ? t.deadline_date : '',
    work_type_ids: (Array.isArray(t.field_works) ? t.field_works : [])
      .map((fw) => fw && fw.type_id)
      .filter((id) => present(id))
      .map(toNumber),
    description: present(t.description) ? String(t.description) : '',
    expenses: present(t.expenses) ? String(t.expenses) : '',
  };
}

function basePayload(form, location) {
  return {
    geo_location_id: location.id,
    title: location.name,
    assignee_id: toNumber(form.assignee_id),
    deadline_date: form.deadline_date,
    work_type_ids: (form.work_type_ids || []).map(toNumber),
    description: String(form.description || ''),
  };
}

export function buildCreatePayload(form, location, draftId) {
  const payload = { id: draftId, ...basePayload(form, location) };
  if (present(form.expenses)) payload.expenses = toNumber(form.expenses);
  return payload;
}

export function buildUpdatePayload(form, location, taskId) {
  return {
    id: taskId,
    ...basePayload(form, location),
    expenses: present(form.expenses) ? toNumber(form.expenses) : null,
  };
}

export function validateTaskForm(form, { mode, today }) {
  const errors = [];
  if (!present(form.assignee_id)) errors.push('Выберите исполнителя.');
  if (!present(form.deadline_date) || !ISO_DATE_RE.test(String(form.deadline_date))) {
    errors.push('Укажите дедлайн.');
  } else if (mode === 'create' && String(form.deadline_date) < today) {
    errors.push('Дедлайн не может быть раньше сегодняшнего дня.');
  }
  if (present(form.expenses)) {
    const n = Number(form.expenses);
    if (!Number.isFinite(n) || n < 0) errors.push('Прочие расходы должны быть неотрицательным числом.');
  }
  return errors;
}

export function mergeEngineerOptions(engineers, task) {
  const options = (Array.isArray(engineers) ? engineers : [])
    .map((e) => ({ id: toNumber(e.id), label: String(e.username || e.email || `#${e.id}`), missing: false }));
  const currentId = task && present(task.assignee_id) ? toNumber(task.assignee_id) : null;
  if (currentId !== null && !options.some((o) => o.id === currentId)) {
    const name = (task.assignee && task.assignee.username) || `#${currentId}`;
    options.push({ id: currentId, label: `${name} (не инженер)`, missing: true });
  }
  return options;
}

export function mergeWorkTypeOptions(workTypes, task) {
  const options = (Array.isArray(workTypes) ? workTypes : [])
    .map((w) => ({ id: toNumber(w.id), label: String(w.title || `#${w.id}`), missing: false }));
  const works = task && Array.isArray(task.field_works) ? task.field_works : [];
  works.forEach((fw) => {
    if (!fw || !present(fw.type_id)) return;
    const id = toNumber(fw.type_id);
    if (options.some((o) => o.id === id)) return;
    const title = (fw.type && fw.type.title) || `Вид работ #${id}`;
    options.push({ id, label: `${title} (в архиве)`, missing: true });
  });
  return options;
}
